import { useQuery } from "@tanstack/react-query";
import { from } from "@vixio/data";
import { countRows } from "@vixio/forms-ui";

/** Dados dos painéis do Início: ficam fora das telas para que elas carreguem sob demanda. */
export function useSurveyKpis(orgId: string) {
  return useQuery({
    queryKey: ["surveys", "kpis", orgId],
    queryFn: async () => {
      const [fieldwork, planning, pending, flagged, candidates] = await Promise.all([
        countRows(from("surveys", "projects").select("id", { count: "exact", head: true }).eq("org_id", orgId).eq("status", "fieldwork")),
        countRows(from("surveys", "projects").select("id", { count: "exact", head: true }).eq("org_id", orgId).eq("status", "planning")),
        countRows(from("surveys", "v_responses").select("id", { count: "exact", head: true }).eq("org_id", orgId).eq("status", "pending")),
        countRows(from("surveys", "v_responses").select("id", { count: "exact", head: true }).eq("org_id", orgId).eq("status", "flagged")),
        countRows(from("surveys", "interviewers").select("id", { count: "exact", head: true }).eq("org_id", orgId).eq("status", "candidate")),
      ]);
      return { fieldwork, planning, pending, flagged, candidates };
    },
  });
}
